import type { ClientCapabilities } from "./types";

/** Audited against origin/main console.ts at 48cb983b2d0a (4 Nov 2026). */
export const httpCapabilities = {
  workspace: {
    organization: { source: "derived", endpoint: "GET /apps/v1/me" },
    currentUser: { source: "live", endpoint: "GET /apps/v1/me" },
    projects: { source: "derived", endpoint: "GET /apps/v1/me" },
    project: { source: "derived", endpoint: "GET /apps/v1/me" },
    members: {
      source: "unavailable",
      reason: "The console API does not expose workspace.members yet.",
    },
    invitations: {
      source: "unavailable",
      reason: "The console API does not expose workspace.invitations yet.",
    },
  },
  accounts: {
    list: { source: "live", endpoint: "GET /apps/v1/projects/:projectId/accounts" },
    get: { source: "derived", endpoint: "GET /apps/v1/projects/:projectId/accounts" },
    needingAttention: {
      source: "derived",
      endpoint: "GET /apps/v1/projects/:projectId/accounts",
    },
    statusCounts: {
      source: "derived",
      endpoint: "GET /apps/v1/projects/:projectId/accounts",
    },
    providerCounts: {
      source: "derived",
      endpoint: "GET /apps/v1/projects/:projectId/accounts",
    },
  },
  endUsers: {
    list: {
      source: "unavailable",
      reason: "The console API does not expose endUsers.list yet.",
    },
    get: {
      source: "unavailable",
      reason: "The console API does not expose endUsers.get yet.",
    },
  },
  hostedAuth: {
    create: {
      source: "unavailable",
      reason: "The console API does not expose hostedAuth.create yet.",
    },
  },
  mail: {
    threads: {
      source: "unavailable",
      reason: "The console API does not expose mail.threads yet.",
    },
    thread: {
      source: "unavailable",
      reason: "The console API does not expose mail.thread yet.",
    },
    emails: {
      source: "unavailable",
      reason: "The console API does not expose mail.emails yet.",
    },
    drafts: {
      source: "unavailable",
      reason: "The console API does not expose mail.drafts yet.",
    },
    folders: {
      source: "unavailable",
      reason: "The console API does not expose mail.folders yet.",
    },
  },
  calendar: {
    calendars: {
      source: "unavailable",
      reason: "The console API does not expose calendar.calendars yet.",
    },
    week: {
      source: "unavailable",
      reason: "The console API does not expose calendar.week yet.",
    },
    events: {
      source: "unavailable",
      reason: "The console API does not expose calendar.events yet.",
    },
    event: {
      source: "unavailable",
      reason: "The console API does not expose calendar.event yet.",
    },
    busy: {
      source: "unavailable",
      reason: "The console API does not expose calendar.busy yet.",
    },
  },
  contacts: {
    list: {
      source: "unavailable",
      reason: "The console API does not expose contacts.list yet.",
    },
    get: {
      source: "unavailable",
      reason: "The console API does not expose contacts.get yet.",
    },
    groups: {
      source: "unavailable",
      reason: "The console API does not expose contacts.groups yet.",
    },
  },
  platform: {
    metrics: {
      source: "unavailable",
      reason: "The console API does not expose platform.metrics yet.",
    },
    usage: {
      source: "unavailable",
      reason: "The console API does not expose platform.usage yet.",
    },
    apiKeys: { source: "live", endpoint: "GET /apps/v1/projects/:projectId/keys" },
    webhooks: {
      source: "unavailable",
      reason: "The console API does not expose platform.webhooks yet.",
    },
    webhook: {
      source: "unavailable",
      reason: "The console API does not expose platform.webhook yet.",
    },
    deliveries: {
      source: "unavailable",
      reason: "The console API does not expose platform.deliveries yet.",
    },
    auditEvents: { source: "live", endpoint: "GET /apps/v1/projects/:projectId/audit" },
  },
  billing: {
    period: {
      source: "unavailable",
      reason: "The console API does not expose billing.period yet.",
    },
    invoices: {
      source: "unavailable",
      reason: "The console API does not expose billing.invoices yet.",
    },
  },
  messaging: {
    chats: {
      source: "unavailable",
      reason: "The console API does not expose messaging.chats yet.",
    },
    chat: {
      source: "unavailable",
      reason: "The console API does not expose messaging.chat yet.",
    },
    messages: {
      source: "unavailable",
      reason: "The console API does not expose messaging.messages yet.",
    },
    chatsWithMessages: {
      source: "unavailable",
      reason: "The console API does not expose messaging.chatsWithMessages yet.",
    },
    profiles: {
      source: "unavailable",
      reason: "The console API does not expose messaging.profiles yet.",
    },
    invites: {
      source: "unavailable",
      reason: "The console API does not expose messaging.invites yet.",
    },
    posts: {
      source: "unavailable",
      reason: "The console API does not expose messaging.posts yet.",
    },
    comments: {
      source: "unavailable",
      reason: "The console API does not expose messaging.comments yet.",
    },
  },
} as const satisfies ClientCapabilities;

export const fixtureCapabilities: ClientCapabilities = Object.fromEntries(
  Object.entries(httpCapabilities).map(([group, methods]) => [
    group,
    Object.fromEntries(
      Object.keys(methods).map((method) => [
        method,
        {
          source: "fixtures",
          note: "Invented demo data, never customer data.",
        },
      ]),
    ),
  ]),
) as ClientCapabilities;
